import { render, staticRenderFns } from "./ListItemDetails.vue?vue&type=template&id=88c684cc&"
import script from "./ListItemDetails.vue?vue&type=script&lang=js&"
export * from "./ListItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports